import styled from 'styled-components';

/* Mixins */
import {
  WebFontBody1,
  WebFontBody2,
  WebFontCallout1,
  WebFontCallout2,
} from 'styles/Mixins';

/* Utils */
import { mediaQuery } from 'styles/Utils';

export const ColumnWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  margin-left: 16px;
`;

export const ContentWrapper = styled.div`
  margin-top: 2px;
  width: 100%;
  ${mediaQuery.desktop`
    ${WebFontBody1}
  `}
  ${mediaQuery.mobile`
    ${WebFontBody2}
  `}
  color: ${({ theme }) => theme.Grey1};
  line-height: 24px;
  text-align: left;
`;

export const TitleWrapper = styled.div`
  display: flex;
  align-items: flex-start;
`;

export const Title = styled.div`
  ${mediaQuery.desktop`
    ${WebFontCallout1}
  `}
  ${mediaQuery.mobile`
    ${WebFontCallout2}
  `}
  text-align: initial;
  color: ${({ theme }) => theme.Grey1};
  margin-left: 8px;
`;

export const RadioBox = styled.div<{
  selected?: boolean;
}>`
  display: flex;
  border-radius: 6px;
  align-items: center;
  padding: 16px;
  box-sizing: border-box;
  ${({ selected }) =>
    !selected && 'box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.12);'};
  ${({ selected, theme }) =>
    `border: 1px solid ${selected ? theme.darkCobalt : 'transparent'}`};
  transition: linear 0.1s border;
  ${mediaQuery.desktop`
    margin: 8px 8px 24px 8px;
  `}
  ${mediaQuery.mobile`
    margin: 8px;
  `}
  min-height: 95px;
`;
